import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Button, Grid, InputLabel, withStyles } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader.js";
import CustomeTextField from "components/UpdateUi/CustomeTextField.js";
import brandTheme from "brandTheme/Theme.js";
import CustomeSelectNew from "components/UpdateUi/CustomeSelect.js";

import { headerLabel } from "assets/properties/properties";
import { purposeOfLoanListData } from "assets/properties/properties";
import { purposeOfLoanNewList } from "assets/properties/properties";
import FileUploadDocument from "components/FileUpload/FileUploadDocument";
import { removeSpecialCharFileName } from "utils/Utils";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";

const styles = () => ({
    mainContainer:{
        width:'95%',
        margin:'0 auto',
        boxShadow:'0 10px 15px rgba(0,0,0,0.04)',
        border:'1px solid rgba(0,0,0,0.04)',
        padding:'10px 20px'
    },
    uploadContainer:{
        '& div[role="button"]': {
            height:'150px !important',
            margin:'0px 10px !important',
        },

    },
});
const LoanDetailsPurpose = ({
  classes,
  editable,
  outletData,
  purposeOfLoan,
  setPurposeOfLoan,
   meanPurposeOfLoan,
    setMeanPurposeOfLoan,
    occupationProofDocLink,
    setOccupationProofDocLink,
    occupationProofDocName,
    setOccupationProofDocName,
    PurposeOfLoanList,
    showOtherIncome,
    filterPurposeOfloan
}) => {



  const { authToken } = useSelector((state) => state.login.authData);
  let occupationRef = useRef();
  const UploadFile = async (file) => {
    const formData = new FormData();
    const fileName = removeSpecialCharFileName(file.name);
    formData.append("file", file, fileName);
    //   setCallInProgress(true)
    const path = await apiHandler({
      url: endpoint.FILE_UPLOAD,
      method: "POST",
      authToken: authToken,
      data: formData,
    });
    //   setCallInProgress(false)
    const uploadedPath = path.data;
    setOccupationProofDocLink(uploadedPath?.name);
  };
  useEffect(() => {
    if (meanPurposeOfLoan === purposeOfLoanNewList?.consumption) {
      setOccupationProofDocName("");
      setOccupationProofDocLink("");
    }
  }, [
    meanPurposeOfLoan,
    setOccupationProofDocName,
    setOccupationProofDocLink,
  ]);
  
  return (
      <Grid container spacing={2} className={classes.mainContainer}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={classes.applicantPageContainer}
        >
          <SubHeader label={headerLabel?.loanInformation} />
        </Grid>
  
      <Grid item xs={12} sm={12} md={3} className={classes.fieldContaienr}>
        <CustomeSelectNew
          label="Purpose Of Loan*"
          id="purpose_of_loan"
          value={
            meanPurposeOfLoan
          }
          setState={setMeanPurposeOfLoan}
          data={
            filterPurposeOfloan
              ? purposeOfLoanNewList?.meanPurposeOfLoanList?.filter(
                  item => item === "Consumption"
                )
              : purposeOfLoanNewList?.meanPurposeOfLoanList
          }
          disabled={!editable}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={3} className={classes.fieldContaienr}>
        <CustomeSelectNew
          label="Purpose Of Loan Type*"
          id="purpose_of_loan"
          value={purposeOfLoan}
          setState={setPurposeOfLoan}
          data={
            meanPurposeOfLoan === purposeOfLoanNewList?.income
              ? purposeOfLoanNewList?.incomeGeneratedPurposeOfLoan
              : PurposeOfLoanList
          }
            disabled={!editable }
        />
      </Grid>
      { meanPurposeOfLoan === purposeOfLoanNewList?.income  && 
        (purposeOfLoan === purposeOfLoanNewList?.agriculture ||
          purposeOfLoan === purposeOfLoanNewList?.business) && (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              className={classes.fieldContaienr}
            >
              <CustomeSelectNew
                label="Document Type*"
                id="document_type"
                value={occupationProofDocName}
                setState={setOccupationProofDocName}
                data={
                  purposeOfLoanNewList?.agriculture === purposeOfLoan
                    ? purposeOfLoanNewList?.agricultureList
                    : purposeOfLoanNewList?.businessList
                }
                disabled={!editable }
              />
            </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={3}
                className={`${classes.fieldContaienr} ${classes.uploadContainer}`}
                style={{display:'flex'}}
              >
                <FileUploadDocument
                  addButtonProps={{ color: brandTheme.buttonColor }}
                  changeButtonProps={{ color: brandTheme.buttonColor }}
                  removeButtonProps={{ color: brandTheme.button2Color }}
                  supportedMimeType={[
                    "image/jpeg",
                    "image/bmp",
                    "image/png",
                    "image/tiff",
                    "application/pdf",
                  ]}
                  sendFile={(file) => UploadFile(file)}
                  removeFile={() => setOccupationProofDocLink("")}
                  previewImage={occupationProofDocLink}
                  ref={occupationRef}
                  removeButton={!editable}
                  name={!editable}
                />
              </Grid>
          </>
        )}
    </Grid>
  );
};

LoanDetailsPurpose.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.object,
};

export default withStyles(styles)(LoanDetailsPurpose);
